import type { ReactNode } from 'react';
import { Header } from './Header';
import { PageBackground } from './PageBackground';
import { AdminSidebar } from './AdminSidebar';
import { useAuth } from '../../contexts/AuthContext';

interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';

  return (
    <PageBackground>
      <Header />
      <AdminSidebar />
      <div className={isAdmin ? 'lg:pl-14' : ''}>
        <main className="max-w-7xl mx-auto px-6 py-8 lg:px-12">
          {children}
        </main>
      </div>
    </PageBackground>
  );
}
